
const SourceField = {
    NONE: "NONE",
    SCALAR: "SCALAR",
    OBJECT: "OBJECT",
    OBJECT_AND_SCALAR: "OBJECT_AND_SCALAR"
};
export default SourceField;
